var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconReport = function SvgIconReport(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 20.251 24",
    width: 20.251,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-197.875 -142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.625 165.25h-13.5a1.5 1.5 0 0 1 -1.5-1.5v-16.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.375 160.159a1.8 1.8 0 0 1 -1.75 1.841h-12.25a1.8 1.8 0 0 1 -1.75-1.841v-15.568a1.8 1.8 0 0 1 1.75-1.841h8.9a1.707 1.707 0 0 1 1.238.539l3.349 3.524a1.887 1.887 0 0 1 .513 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-528.875 -286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m535.75 292.75h8.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.75 297.25h8.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.75 301.75h3.75"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconReport.030b76b2.svg";
export { ForwardRef as ReactComponent };